export default __webpack_public_path__ + "static/media/location-arrow.d519b120.svg";